import fetch from 'cross-fetch'
import getApiLocation from './getApiLocation'
import { getAuthToken } from '@/lib/authentication'
import validateResult from './validateResult'

// Multipart upload -- deliberately does NOT set Content-Type so the browser can set the
// multipart boundary itself. Field names are the caller's to choose so this serves any
// [FromForm] request, not one hard-coded shape: pass the file's field name and any sibling
// text fields the request declares.
const postFile = ({ path, file, fields = {}, fileField = 'File' }) => {
  const apiLocation = getApiLocation()
  const formData = new FormData()
  Object.keys(fields).forEach(key => formData.append(key, fields[key]))
  formData.append(fileField, file)

  return fetch(`${apiLocation}/${path}`, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + getAuthToken()
    },
    body: formData
  })
    .then(res => res.json().catch(() => null).then(body => {
      if (res.status === 401) {
        validateResult(res)
        return body
      }

      // Surface the server's own message on a rejection -- a too-big or wrong-extension file
      // carries a reason the admin needs to read, and it lives in the response body, not the
      // status line.
      if (res.status >= 400) {
        throw new Error((body && body.errorMessage) || 'File upload failed.')
      }

      return body
    }))
}

export default postFile
